// import { createSelector } from 'reselect';

const selLoadPending = state => state.pageVolunteerMe.loadPending;

export default {
  loadPending: selLoadPending,
};
